import React, { Component } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { red, green } from '@mui/material/colors';
import OutlinedDiv from './Attributes/Styles/OutlinedDiv';
import DataStore from './../stores/DataStore'
import { observer } from "mobx-react";
// import SaveChangesHandler from '../SaveChangesHandler';

/**
 * @class
 * Modul zum anzeigen der Zusammenfassung nach dem Bearbeiten der Attribute
 */
class SummaryModul extends Component {
  /**
   * @constructor
   * @param {} params
   */
  constructor(params) {
    super(params);
    this.state = { loadingState: -1, message: null }; // -1 = nichts am passieren, 0=loading, 1=success, 2=error, 3=problem
    this.DataStore = DataStore;
  }

  componentDidMount() {
    this.DataStore.onHandlerSet.push(() =>
      this.DataStore.saveChangesHandler && this.DataStore.saveChangesHandler.setSummaryModul(this)
    )//getHandler().saveChangesHandler.setSummaryModul(this);
  }

  // setSuccess() {
  //   this.setState({ loadingState: 1 });
  // }

  // setLoading() {
  //   this.setState({ loadingState: 0 });
  // }

  // setError(message) {
  //   this.setState({ loadingState: 2, message });
  // }

  // setNothing() {
  //   this.setState({ loadingState: -1 });
  // }

  getColorString() {
    const { state } = DataStore.requestStore.requests[DataStore.saveKey];;
    let color = '';
    switch (state) {
      case 0:
        color = 'yellow';
        break;
      case 1:
        color = 'green';
        break;
      case 2:
        color = 'red';
        break;
      default:
        color = '';
    }
    return color;
  }

  getSummary() {
    const sumFields = this.getSummeryOfData();

    return (
      <OutlinedDiv
        label="Zusammenfassung"
        style={{
          width: '90%',
          float: 'left',
        }}
      >
        {' '}
        {sumFields}
      </OutlinedDiv>
    );
  }

  /**
   * ..Eventuell wird die unterscheidung nach den ganzen verschiedenen Daten noch in die einzelnen AttributModule (mit getString() oder sowas) verschoben
   */
  getSummeryOfData() {
    if (this.DataStore.getInitialConfig().every(atr => typeof this.DataStore.attributeValues[atr.id].modul != typeof undefined))
      return this.DataStore.getInitialConfig().map(atr => this.DataStore.attributeValues[atr.id].modul.getSummaryDisplay())
    return []

    // const color = this.getColorString();
    // const containsIDNested = function(dataArr, id) {
    //   let dataArrSub = dataArr
    //     .filter(
    //       o =>
    //         Array.isArray(o.value) &&
    //         o.value.every(
    //           v =>
    //             typeof v.key !== 'undefined' && typeof v.value !== 'undefined',
    //         ),
    //     )
    //     .map(o => o.value);
    //   dataArrSub = dataArrSub.filter(o => containsIDNested(o, id));
    //   return (
    //     dataArr.filter(o => o.key === id).length >= 1 || dataArrSub.length >= 1
    //   );
    // };
    // this.messageHandler.logDebug(data);
    // data
    //   .filter(
    //     d => typeof d.value !== 'undefined', // && typeof d.value !== 'object',
    //   )
    // // this.messageHandler.logDebug(sumFields);
    // return sumFields;
  }

  getHeader() {
    const { state, message } = DataStore.requestStore.requests[DataStore.saveKey];
    let icon = <div />;
    let text = '';
    switch (state) {
      case "nothing":
        icon = <CircularProgress />;
        text = '..Noch nichts zu sehen..';
        break;
      case "loading":
        icon = <CircularProgress />;
        text = 'Daten werden gesendet';
        break;
      case "success":
        icon = (
          <CheckCircleOutlineIcon style={{ color: green[500], fontSize: 40 }} />
        );
        text = 'Speichern erfolgreich!';
        break;
      case "error":
        icon = <CancelOutlinedIcon style={{ color: red[500], fontSize: 40 }} />;
        text = 'Fehler beim Speichern! \n' + message;
        break;
      default:
        icon = <div />;
    }
    return (
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        {icon}
        <div>{text}</div>
      </div>
    );
  }

  getMessage() {
    const { state, message } = DataStore.requestStore.requests[DataStore.saveKey]//this.state;
    if (state >= 2 && message) {
      if (message)
        return (
          <div style={{ marginTop: '20px', color: this.getColorString() }}>
            {message}
          </div>
        );
      return (
        <div style={{ marginTop: '20px', color: this.getColorString() }}>
          Fehler ohne genauere Beschreibung
        </div>
      );
    }
    return <div />;
  }

  render() {
    if (DataStore.requestStore.requests[DataStore.saveKey] == undefined) return <div />
    return (
      <div>
        {this.getHeader()}
        {this.getSummary()}
        {this.getMessage()}
      </div>
    );
  }
}
export default observer(SummaryModul);
